class InputActionButtons {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('[data-input]').forEach(el => {
            if (el.nextElementSibling.getAttribute('data-input-action') == 'submit'){
                el.nextElementSibling.addEventListener('click', () => {
                    el.parentElement.submit()
                })
            } else if (el.nextElementSibling.getAttribute('data-input-action') == 'close'){
                el.nextElementSibling.addEventListener('click', () => {
                    el.value = ""
                })
            } 
            if (el.nextElementSibling.nextElementSibling.getAttribute('data-input-action') == 'close'){
                el.nextElementSibling.nextElementSibling.addEventListener('click', () => {
                    el.value = ""
                })
            }
        })
    }

}

export default InputActionButtons